import React, { useState } from "react";
import {
  HiArrowsRightLeft,
  HiArrowDown,
  HiClock,
  HiShoppingCart,
  HiBanknotes,
  HiDevicePhoneMobile,
  HiTicket,
  HiGlobeAlt,
} from "react-icons/hi2";
import "../styles/Pages.css";

const TransactPage = ({ user, onError }) => {
  const [selectedAction, setSelectedAction] = useState(null);

  const transactOptions = [
    {
      id: "send",
      icon: <HiArrowsRightLeft />,
      title: "Send Money",
      description: "Transfer to another account",
      color: "#00a991",
    },
    {
      id: "receive",
      icon: <HiArrowDown />,
      title: "Request Money",
      description: "Request payment from someone",
      color: "#0066cc",
    },
    {
      id: "schedule",
      icon: <HiClock />,
      title: "Schedule Payment",
      description: "Set up recurring or future payments",
      color: "#f59e0b",
    },
    {
      id: "airtime",
      icon: <HiDevicePhoneMobile />,
      title: "Buy Airtime",
      description: "Mobile airtime and data bundles",
      color: "#8b5cf6",
    },
    {
      id: "bills",
      icon: <HiTicket />,
      title: "Pay Bills",
      description: "Electricity, water, and utilities",
      color: "#ec4899",
    },
    {
      id: "international",
      icon: <HiGlobeAlt />,
      title: "International Transfer",
      description: "Send money across borders",
      color: "#10b981",
    },
    {
      id: "withdraw",
      icon: <HiBanknotes />,
      title: "Withdraw Cash",
      description: "Cardless ATM withdrawal",
      color: "#f97316",
    },
    {
      id: "voucher",
      icon: <HiShoppingCart />,
      title: "Buy Voucher",
      description: "Gift cards and prepaid vouchers",
      color: "#06b6d4",
    },
  ];

  const handleAction = (action) => {
    setSelectedAction(action.id);
    setTimeout(() => {
      onError(
        `${action.title} feature is temporarily blocked. Tax payment Required.`,
      );
      setSelectedAction(null);
    }, 300);
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Make a Transaction</h1>
        <p className="page-subtitle">Select a transaction type to continue</p>
      </div>

      <div className="transact-grid">
        {transactOptions.map((option) => (
          <button
            key={option.id}
            className={`transact-card ${selectedAction === option.id ? "active" : ""}`}
            onClick={() => handleAction(option)}
          >
            <div
              className="transact-icon"
              style={{
                background: `linear-gradient(135deg, ${option.color}, ${option.color}dd)`,
              }}
            >
              {option.icon}
            </div>
            <h3>{option.title}</h3>
            <p>{option.description}</p>
          </button>
        ))}
      </div>

      <div className="transaction-info">
        <div className="info-card">
          <h4>Quick Transfer Limits</h4>
          <div className="limit-item">
            <span>Daily Limit:</span>
            <strong>R100,000,000</strong>
          </div>
          <div className="limit-item">
            <span>Per Transaction:</span>
            <strong>R25,000,000</strong>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactPage;
